<script>
  import { onMount } from 'svelte';
  import { authorize, authorized } from './auth.js';
  import Header from './Header.svelte';
  import Form from './Form.svelte';
  import Error from './Error.svelte';
  import Unsubscribe from './Unsubscribe.svelte';
  import Subscribe from './Subscribe.svelte';
  let access_token;
  let authenticating = true;

  onMount(async () => {
    await authorize();
    authenticating = false;
  })
</script>

{#if authenticating}
  <p>Authenticating...</p>
{:else if $authorized}
  <Header />
  <Form />
  <Subscribe />
  <Unsubscribe />
{:else}
  <Error />
{/if}
